import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yearsMonthConverter'
})
export class YearsMonthConverterPipe implements PipeTransform {

  transform(valuex: number | string, abbr?: boolean): string {

    if (!valuex) {
      return '-';
    }

    const value = parseFloat(valuex.toString());

    // (int)Math.Floor(x.LeaseExpiration.Value.Subtract(DateTime.Now).Days / (365.25 / 12))
    const months = Math.floor((value / (365.25 / 12))); // actual months

    const years = Math.floor(months / 12);

    const yrs = years > 1 ? (abbr ? 'yrs' : 'years') : (abbr ? 'yr' : 'year');
    const mnts = (months % 12) > 1 ? (abbr ? 'mo' : 'months') : (abbr ? 'mo' : 'month');

    const days = +valuex > 1 ? 'days' : (abbr ? 'd' : 'day');

    if (years > 0 && (months % 12) === 0) {
      return `${years} ${yrs}`;
    } else if (years === 0 && (months % 12) > 0) {
      return `${(months % 12)} ${mnts}`;
    } else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {

      if (years === 0 && months === 0 && +valuex > 0) {
        return `${valuex} ${days}`;
      }

      return `Expired`;
    } else {
      return `${years} ${yrs} & ${(months % 12)} ${mnts}`;
    }
  }

}
